import React from "react";

import {videosData as VData} from './videosData.js'

import background from "./../../../UI/icons/Galerias/background.svg";

import close from "./../../../UI/icons/Galerias/Close.svg";
import next from "./../../../UI/icons/Galerias/next.svg";
import prev from "./../../../UI/icons/Galerias/prev.svg";

interface Props {
  videosOpened: boolean;
  handleVideos: any;
}

interface State {
  ImageArray: any;
  fullGallery: boolean;
  currentImage: any;
  currentImageIndex: number;
}

class Videos extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      ImageArray: [],
      fullGallery: false,
      currentImage: [],
      currentImageIndex: -1,
    };
  }

  componentDidUpdate(prevProps: any) {
    if(prevProps.videosOpened !== this.props.videosOpened){
    this.handleGetGaleria();
    }
  }

  handleGetGaleria = () => {
      console.log('aqui');
      
    if (VData()) {
      let arrayMixed: any = [];
      VData().forEach((r: any) => {
        arrayMixed.push({
          path: "Video",
          img: r.Imagen,
          link: r.Link,
          nombre: r.Nombre,
        });
      });

      this.setState({ ImageArray: arrayMixed });
    }
  };

  handleGetThumbs = () => {
    return (
      <div className="thumbs-gallery">
        {this.state.ImageArray.map((thumbs: any, index: number) => (
          <div className="gallery-thumb-container" key={index}>
            <img
              className="gallery-thumb"
              alt=""
              src={thumbs.img}
              onClick={() => {
                this.handleOpenGallery(index);
              }}
            />
            <div>{thumbs.nombre}</div>
          </div>
        ))}
      </div>
    );
  };

  handleOpenGallery = (index: number) => {
    this.setState({
      fullGallery: !this.state.fullGallery,
      currentImageIndex: index,
    });
  };

  handleNextImage = () => {
    this.state.currentImageIndex + 1 > this.state.ImageArray.length - 1
      ? this.setState({ currentImageIndex: 0 })
      : this.setState({ currentImageIndex: this.state.currentImageIndex + 1 });
  };

  handlePrevImage = () => {
    this.state.currentImageIndex - 1 < 0
      ? this.setState({ currentImageIndex: this.state.ImageArray.length - 1 })
      : this.setState({ currentImageIndex: this.state.currentImageIndex - 1 });
  };

  render() {
    return (
      <React.Fragment>
        <div
          className={
            this.props.videosOpened
              ? "general-proyecto fade-in"
              : "general-proyecto fade-out"
          }
        >
          <img className="proyectos-background" src={background} />
          <div
            className="close-proyecto"
            onClick={() => {
              this.props.handleVideos('videos');
            }}
          >
            <img src={close}></img>
          </div>
          {this.state.ImageArray.length > 0 ? this.handleGetThumbs() : null}
        </div>
        <div
          className={
            this.state.fullGallery
              ? "full-proyecto fade-in"
              : "full-proyecto fade-out"
          }
        >
          <img className="proyectos-background" src={background} />
          <iframe className="gallery-video" src={this.state.ImageArray.length > 0 &&
              this.state.currentImageIndex !== -1
                ? this.state.ImageArray[this.state.currentImageIndex].link +"?rel=0?version=3&autoplay=1&controls=0&loop=1&showinfo=0" : ""} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; loop"/>
          <div
            className="close-proyecto"
            onClick={() => {
              this.handleOpenGallery(-1);
            }}
          >
            <img src={close}></img>
          </div>
          {this.state.ImageArray.length > 1 ? (
            <React.Fragment>
              <div
                className="next-proyecto"
                onClick={() => {
                  this.handleNextImage();
                }}
              >
                <img src={next}></img>
              </div>
              <div
                className="previous-proyecto"
                onClick={() => {
                  this.handlePrevImage();
                }}
              >
                <img src={prev}></img>
              </div>
            </React.Fragment>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}

export default Videos;
